import React, { useState, useEffect, useContext } from "react";
import Templete from "../Templete/Templete";
import AuthService from "../../../services/Admin/AuthService";
import RechargeService from "../../../services/Admin/RechargeService";
import LoadingContext from "../../../store/loading-context";

const ApiSummary = () => {
  const loadingCtx = useContext(LoadingContext);

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);

  const fetchData = async () => {
    const token = AuthService.getAccessToken();
    setLoading(true);

    try {
      const responseData = await RechargeService.apiSummary(
        token,
        fromDate,
        toDate
      );
      if (responseData.status !== "SUCCESS") {
        throw new Error(responseData.message);
      }

      const { data: reportData, summary: reportSummary } = responseData.data;
      setData(reportData);
      setSummary(reportSummary);
    } catch (err) {
      console.error("Error fetching report:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Templete t1="Home" t2="API Summary">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">API Summary</h3>
                  </div>

                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3">
                        <input
                          type="date"
                          className="form-control"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-3">
                        <input
                          type="date"
                          className="form-control"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-6 text-center">
                        <button
                          className="btn btn-primary"
                          onClick={fetchData}
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{" "}
                              Loading...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-search"></i> Search
                            </>
                          )}
                        </button>
                      </div>
                    </div>

                    {/* Loading indicator */}
                    {loading && (
                      <div className="text-center mb-3">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        ></div>
                        <p>Fetching data...</p>
                      </div>
                    )}

                    {/* Table */}
                    {!loading && data && data.length > 0 && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead className="thead-dark">
                            <tr>
                              <th>#</th>
                              <th>API Name</th>
                              <th>Total Txns</th>
                              <th>Total Amount</th>
                              <th>Success Count</th>
                              <th>Success Amount</th>
                              <th>Pending Count</th>
                              <th>Pending Amount</th>
                              <th>Failed Count</th>
                              <th>Failed Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((row, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row["API Name"]}</td>
                                <td>{row.total_counts}</td>
                                <td>
                                  ₹{parseFloat(row.total_amount).toFixed(2)}
                                </td>

                                <td
                                  style={{ color: "green", fontWeight: "bold" }}
                                >
                                  {row.success_count}
                                </td>
                                <td
                                  style={{ color: "green", fontWeight: "bold" }}
                                >
                                  ₹{parseFloat(row.success_amount).toFixed(2)}
                                </td>

                                <td
                                  style={{
                                    color: "#ff9800",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {row.pending_count}
                                </td>
                                <td
                                  style={{
                                    color: "#ff9800",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ₹{parseFloat(row.pending_amount).toFixed(2)}
                                </td>

                                <td
                                  style={{ color: "red", fontWeight: "bold" }}
                                >
                                  {row.failed_count}
                                </td>
                                <td
                                  style={{ color: "red", fontWeight: "bold" }}
                                >
                                  ₹{parseFloat(row.failed_amount).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr
                              style={{
                                backgroundColor: "#e0e0e0",
                                fontWeight: "bold",
                              }}
                            >
                              <td colSpan="2" className="text-right">
                                Total
                              </td>
                              <td>{summary?.total_counts || 0}</td>
                              <td>
                                ₹
                                {parseFloat(summary?.total_amount || 0).toFixed(
                                  2
                                )}
                              </td>
                              <td style={{ color: "green" }}>
                                {summary?.success_count || 0}
                              </td>
                              <td style={{ color: "green" }}>
                                ₹
                                {parseFloat(
                                  summary?.success_amount || 0
                                ).toFixed(2)}
                              </td>
                              <td style={{ color: "#ff9800" }}>
                                {summary?.pending_count || 0}
                              </td>
                              <td style={{ color: "#ff9800" }}>
                                ₹
                                {parseFloat(
                                  summary?.pending_amount || 0
                                ).toFixed(2)}
                              </td>
                              <td style={{ color: "red" }}>
                                {summary?.failed_count || 0}
                              </td>
                              <td style={{ color: "red" }}>
                                ₹
                                {parseFloat(
                                  summary?.failed_amount || 0
                                ).toFixed(2)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}

                    {!loading && data.length === 0 && (
                      <p className="text-center text-muted">
                        No records found.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default ApiSummary;
